// src/modules/app-views/offers/pages/Init/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const offersInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [
      dropdownParameters,
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default offersInitMenuButton;
